import { GET_NOTIFICATIONS, REMOVE_NOTIFICATION, SHOW_ALL } from "./constants";

const init = {
  notifications: [],
  showAll: false,
};

const notificationsReducer = (state = init, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.payload.data,
      };
    }
    case REMOVE_NOTIFICATION: {
      const newNotifications = state.notifications.filter((item) => item.id !== action.payload);
      return {
        ...state,
        notifications: [...newNotifications],
      };
    }
    case SHOW_ALL: {
      return {
        ...state,
        showAll: true,
      };
    }
    default:
      return state;
  }
};
export default notificationsReducer;
